<div class="body">
	<!-- HEADER du BODY -->
	<div class="header">
		<div class="contact-profile row-center flex-justify-center">

			<div class="title-visio-button">
				<!-- Titre -->
				<div [ngClass]="conversation?.title ? 'conv-infos' : 'conv-infos add-title'"
					(click)="routeToConversationEditAsync()">
					<p class="clickable">{{ conversation?.title ? conversation.title : "Définissez un titre" }}</p>
				</div>

				<!-- Bouton pour rejoindre la visio en cours -->
				@if (initializedSignal() && canCall && !isMailConversation && isSomeoneInVisio()) {
				<ion-button [disabled]="isCallButtonDisabled" (click)="onCallAsync()" shape="round" size="small" strong="true">
					<ion-icon slot="start" name="videocam"></ion-icon>
					<ion-label>Rejoindre la visio</ion-label>
				</ion-button>
				}
			</div>

			<!-- BOUTONS D'ACTION SUR LA CONVERSATION -->
			<div class="title-icon-linked-entites">
				<!-- Bouton visio -->
				@if (initializedSignal() && canCall && !isMailConversation && !isSomeoneInVisio()) {
				<div class="title-icontxt">
					<ion-icon (click)="onCallAsync()" slot="icon-only" class="title-icon txt24px clickable" aria-label="videocam"
						name="videocam"></ion-icon>
				</div>
				}
				<!-- Bouton édition de la conversation -->
				<div class="title-icontxt">
					<ion-icon (click)="routeToConversationEditAsync()" slot="icon-only" name="create"
						class="title-icon txt24px clickable" aria-label="create">
					</ion-icon>
				</div>
				<!-- Bouton résumé IA -->
				@if(canSummarize && (observableHasMessageForSummarize.value$ | async)) {
				<div class="title-icontxt">
					<ion-icon [color]="(observableUserUsage.value$ | async)?.isQuotaExcedeed ? 'grey' : 'ai-button'"
						(click)="openModalAiSummary()" slot="icon-only" name="color-wand"
						class="title-icon txt24px clickable"></ion-icon>
				</div>
				}

				@let firstLinkedEntityAndAvatar = firstLinkedEntityAndAvatar$ | async;

				<!-- Partie sur les entités liées. Affichée uniquement s'il y a une entitée liée ou qu'on peut en ajouter. -->
				@if (!isMailConversation && (firstLinkedEntityAndAvatar || canAddLink)) {
				<div class="element-lie">
					<!-- Entité liée présente -->
					@if(firstLinkedEntityAndAvatar) {
					<div (click)="goToLinkedEntity(firstLinkedEntityAndAvatar.linkedEntity)"
						class="client-ava wrap image participant row-center flex-justify-center">
						<div class="link-ava">
							<ion-icon slot="icon-only" name="link" class="clickable"></ion-icon>
							<avatar [src]="firstLinkedEntityAndAvatar.avatar" class="v-align">
							</avatar>
						</div>
						<p>{{ firstLinkedEntityAndAvatar.linkedEntityName }}</p>
					</div>
					}
					<!-- Bouton pour ajouter une entité liée -->
					@if(canAddLink) {
					<ion-button [disabled]="(canEdit$ | async) !== true" (click)="selectEntities()" fill="clear">
						<ion-icon slot="icon-only" name="add-link" class="add txt24px" style="color: white">
						</ion-icon>
					</ion-button>
					}
				</div>
				}
			</div>
		</div>
	</div>

	<div class="frame">
		<!-- PARTICIPANTS -->
		<div class="sidepanel">
			<div class="profile">
				<!-- Utilisateur 'moi' -->
				@if(userParticipant) {
				<div (click)="goToParticipant(userParticipant)" class="wrap image participant row-center flex-justify-center">
					<!-- Effet "en train d'écrire" -->
					@if(userParticipant.activity?.activity === 't') {
					<div class="loaderavatar"></div>
					}
					<!-- Avatar de l'utilisateur -->
					<avatar class="v-align" [src]="userParticipant.avatar"
						[ngClass]="userParticipant.activity?.activity === 't' ? 'away avatar-icon' : isStillOnline(userParticipant.activity) ? 'online avatar-icon' : 'offline avatar-icon'">
					</avatar>
					<p>{{ userParticipant.label }}</p>
				</div>
				}
				<!-- Icône visio sur l'utilisateur s'il est en visio -->
				@if (userParticipant?.activity?.isInVisio && isStillOnline(userParticipant?.activity)) {
				<div class="visio-icon">
					<ion-icon name="videocam"></ion-icon>
				</div>
				}
			</div>

			<div class="btnAjout">
				<!-- Bouton "Ajouter un participant". -->
				@if(!isMailConversation) {
				<ion-button [disabled]="(canEdit$ | async) !== true" (click)="updateParticipants()"
					class="marge-icon add-participant" fill="clear">
					<ion-icon slot="icon-only" name="add" class="add txt24px" style="color: #999"></ion-icon>
				</ion-button>
				}
			</div>

			<!-- AUTRES UTILISATEURS -->
			<div id="contacts">
				<div class="participants">
					@if(initializedSignal()) {
					<calao-virtual-scroll [items]="otherParticipantsSignal()" [itemSizeRemSignal]="2.5" [minBufferRem]="10"
						[maxBufferRem]="20" autosize transparent>
						<ng-template let-item="$implicit" let-first="first" let-index="index">
							<div class="contact participant participantsbox" [class.first-participant]="first">
								<div class="mat-badge-ctn">
									<div [matBadgeHidden]="item.model?.email || item.model?.userId" (click)="warningToParticipant(item)"
										matBadge="!" matBadgeColor="warn" matBadgeSize="large" matBadgePosition="below after">
									</div>
								</div>
								<div class="wrap image">
									<!-- Effet "en train d'écrire" -->
									@if(item.activity?.activity === 't') {
									<div class="loaderavatar"></div>
									}
									<avatar [src]="item.avatar"
										[ngClass]="item.activity?.activity === 't' ? 'away avatar-icon' : isStillOnline(item.activity) ? 'online avatar-icon' : 'offline avatar-icon'"
										(click)="goToParticipant(item)" style="width: inherit; height: inherit;" class="v-align">
									</avatar>
									<div class="meta">
									</div>
								</div>
								<!-- Icône visio si le participant est en visio et est en ligne -->
								@if(item.activity?.isInVisio && item.activity?.activity === 'o') {
								<div class="visio-icon">
									<ion-icon name="videocam"></ion-icon>
								</div>
								}
							</div>
						</ng-template>
					</calao-virtual-scroll>
					}
					@else {
					<div class="horizontal-center-spinner">
						<ion-spinner color="medium"></ion-spinner>
					</div>
					}
				</div>
			</div>

		</div>

		<!-- CONTENU (TITRE ET MESSAGES ET ZONE DE TEXTE et ENTITES) -->
		<div class="content">

			<!-- MESSAGES -->
			<ion-content [forceOverscroll]="false" class="messages" #messagesContainer>
				<!-- Note de synchro en cours -->
				@if(isDownloading) {
				<ion-list-header class="synchro-container rotate">
					<ion-note class="synchro-label">Téléchargement des nouveaux messages</ion-note>
					<ion-spinner color="medium"></ion-spinner>
				</ion-list-header>
				}
				<!-- Liste des messages -->
				<ion-list class="messages-list">
					<ng-container *ngFor="let message of messages.changes$ | async;">
						<calao-conversation-message [message]="message" [currentContactId]="currentContactId"
							[otherParticipantsMap]="otherParticipantsMapSignal()" [isMailConversation]="isMailConversation"
							[readIndicators]="findReadIndicators(message._id)"
							(onDeleteMessageClicked)="deleteMessageDefinitely(message)"
							(onMessageLongPress)="openMessagePopover($event, message)" (onMailOpen)="openMailDetail(message)"
							(onEntityClicked)="openEntity($event)"></calao-conversation-message>
					</ng-container>
					<!-- Cas d'un message autogénéré -->
					@if (isMailConversation) {
					<div class="message-info-mail rotate">
						<ion-icon aria-hidden="true" name="mail-sharp"></ion-icon>
						<ion-text>Calaotrade a généré cette conversation pour suivre vos échanges par mail.</ion-text>
					</div>
					}
				</ion-list>
				<!-- Action pour charger plus de messages si possible -->
				@if(infiniteScrollEnabled && messages.length > 0) {
				<ion-infinite-scroll #infiniteScroll (ionInfinite)="loadMoreMessages(infiniteScroll)" threshold="10%"
					position="bottom" class="rotate">
					<ion-infinite-scroll-content loadingText="Chargement des messages...">
					</ion-infinite-scroll-content>
				</ion-infinite-scroll>
				}
			</ion-content>

		</div>
	</div>


	<!-- ZONE D'ENVOI DE MESSAGE -->
	@if(!isMailConversation) {
	<div class="message-input">
		<!-- Loader pour l'envoi d'un message avec pièces jointes. -->
		@if(observableIsMessageSending.value$ | async) {
		<osapp-spinner message="Envoi du message en cours ...">
		</osapp-spinner>
		}

		<!-- Zone de la galerie des pièces jointes si l'utilisateur en ajoute. On la masque pour ne pas avoir la preview des images. -->
		<div [hidden]="true" class="just-flex flex-col">
			<gallery #sendGallery [filePickerVisible]="false" [files]="files" [command$]="galleryCommand$"
				[cameraButtonVisible]="false" [acceptedFiles]="galleryAcceptFiles" (onFilesChanged)="onFilesChanged($event)"
				(onDocumentPicked)="onDocumentPicked($event)"></gallery>
		</div>

		<!-- Formulaire de soumission du message avec un bouton pour ajouter des pièces jointes. -->
		<form class="wrap" (ngSubmit)="onMessageSend()">
			<div class="button-area">
				<ion-button mode="md" (click)="openAttachmentsPopover($event)">
					<ion-icon slot="icon-only" name="add"></ion-icon>
				</ion-button>
			</div>
			<div class="message-area">
				@if(sendOnReturn) {
				<input [(ngModel)]="newMessage.body" (input)="onTapping(newMessage.body)" type="text"
					placeholder="Tapez votre message" name="newMessage" />
				}
				@else {
				<textarea [(ngModel)]="newMessage.body" (input)="onTapping(newMessage.body)" class="message-textarea"
					placeholder="Tapez votre message" name="newMessage" rows="2" cols="35"></textarea>
				}
				<div class="tag-wrapper">
					<ion-button *ngFor="let attachment of newMessage.attachments" (click)="openPendingAttachmentAsync(attachment)"
						shape="round" mode="md" size="small" class="attachment-tag-button">
						<div class="attachment-name">{{ getAttachmentName(attachment) }}</div>
						<div (click)="removeAttachment(attachment, sendGallery)" slot="end">
							<ion-icon name="close"></ion-icon>
						</div>
					</ion-button>
				</div>
			</div>

			<div class="button-area">
				<!-- focus-me -->
				<ion-button [disabled]="!newMessage.canSend" type="submit" class="submit" mode="md">
					<ion-icon slot="icon-only" name="send"></ion-icon>
				</ion-button>
			</div>
		</form>
	</div>
	}
</div>